export * from './slide-bar.component';
export * from './slide-bar.module';
